import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/auth';
import { watchPreloadErrors } from './lib/chunkReload';
import { isVanityHost } from './lib/siteHost';
import '@fontsource-variable/fraunces/wght-italic.css';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');
// A script Vite fails to preload is noted, so "Reload" can ask for it again past the cache.
watchPreloadErrors();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      {/* Vanity Studio (its own host) signs in on its own (src/vanity/identity.ts), so it skips the site's session lookup. */}
      {isVanityHost(window.location.hostname) ? (
        <App />
      ) : (
        <AuthProvider>
          <App />
        </AuthProvider>
      )}
    </BrowserRouter>
  </StrictMode>,
);
